var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutOService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.03701 22L2.19995 16.1629V7.83706L8.03701 2H16.3629L22.2 7.83706V16.1629L16.3629 22H8.03701ZM8.84701 16.5926L12.2 13.2397L15.5529 16.5926L16.7926 15.3529L13.4397 12L16.7926 8.64706L15.5529 7.40735L12.2 10.7603L8.84701 7.40735L7.6073 8.64706L10.9602 12L7.6073 15.3529L8.84701 16.5926Z",
    fill: "#6929E2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutOService);
export default __webpack_public_path__ + "static/media/out_o_service.b7486ee1cbfcd9c10938a787af7493a6.svg";
export { ForwardRef as ReactComponent };